import styled from 'styled-components';

const Center = styled.div`
  text-align: center;
  padding-top: 1rem;
  padding-bottom: 1rem;
`;

const ButtonContainer = styled.div`
  margin-top: 1rem;
`;

const UrlMessage = styled.div`
  font-style: italic;
  font-size: 1.0rem;
`;

export default {
  Center,
  ButtonContainer,
  UrlMessage,
};
